import React from 'react'
import './intro.css'
import photo from './assets/photo.png'
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Intro = () => {

  return (
    <div className='intros' id='Intro'>
      <div className='intro'>
        <img className='photo' src={photo} alt="" />
        <h1 style={{ color: 'white' }}><span className='span'>RAGHAV CHANDAN</span> <br />Highly motivated and enthusiastic under-graduate with a strong
          educational background and a passion for IT. Possesses excellent
          communication and interpersonal skills, allowing for effective
          collaboration with team members and clients. Strong work ethic,
          adaptability, and a willingness to learn and acquire new skills.</h1>
      </div>
      <div id='but'>
        <a href="https://drive.google.com/file/d/1Qgm70p90iXr0LwjoW-3FQqmp7LTWkIvY/view?usp=sharing"  className='resume'>MY RESUME</a>
        <button className='pappu'><AnchorLink className='anchor-but' offset={50} href='#Contact'>CONTACT</AnchorLink></button>
      </div>
    </div>

  )
}

export default Intro
